var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"jumbotron"},[_c('v-container',[_c('h2',[_vm._v("Error 404 - Not Found")]),_c('p',[_vm._v("The requested page does not exist.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }